const state = {
    isDialogVisible: false
};

const getters = {
    isDialogVisible: state => state.isDialogVisible
};

const mutations = {
    setIsDialogVisible: (state, data) => state.isDialogVisible = data
};

export default {
    namespaced: true,
    strict: false,
    state,
    getters,
    mutations
};